/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_SimpleInputs */

const en_mk_cmp_r_simple = /** @type {(inputs: Mk_Cmp_R_SimpleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simplicity for non-technical people`)
};

const id_mk_cmp_r_simple = /** @type {(inputs: Mk_Cmp_R_SimpleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesederhanaan untuk non-teknis`)
};

/**
* | output |
* | --- |
* | "Simplicity for non-technical people" |
*
* @param {Mk_Cmp_R_SimpleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_simple = /** @type {((inputs?: Mk_Cmp_R_SimpleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_SimpleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_simple(inputs)
	return en_mk_cmp_r_simple(inputs)
});